import { render, staticRenderFns } from "./list.html?vue&type=template&id=0b36d265&scoped=true&"
import script from "./ListSchool.vue?vue&type=script&lang=js&"
export * from "./ListSchool.vue?vue&type=script&lang=js&"
import style0 from "./ListSchool.vue?vue&type=style&index=0&id=0b36d265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b36d265",
  null
  
)

export default component.exports